export const FhirResourceTypes = {
  Patient: 'Patient',
  AllergyIntolerance: 'AllergyIntolerance',
  Immunization: 'Immunization',
  FamilyMemberHistory: 'FamilyMemberHistory',
  ServiceRequest: 'ServiceRequest',
  Observation: 'Observation',
  Condition: 'Condition',
  MedicationRequest: 'MedicationRequest',
  MedicationStatement: 'MedicationStatement',
  Procedure: 'Procedure',
  DiagnosticReport: 'DiagnosticReport',
  Encounter: 'Encounter',
  Composition: 'Composition',
  Binary: 'Binary',
  DocumentReference: 'DocumentReference'
};
